export default "__VITE_ASSET__CHL3DMz$__"